const withStyle = (record, index) => ({
	backgroundColor: (typeof record['isActive']) ? (record.isActive ? '#efe' : '#eee') : 'none'
});

export const withSource = (path) => (record, index) => withStyle(record[path], index);

export default withStyle;
